// Change in Cart
function updateQuantity(line, quantity) {
  $.ajax({
    type: "POST",
    url: "/cart/change",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {},
  });
}
// ===============================================================================
// Fetch product to cart Drawer
$(document).ready(function () {
  $(document).on(
    "click",
    "button[data-add-to-cart], #colorbox .quickbuy__submit",
    function (e) {
      e.preventDefault();
      var data = $(this).parents("form").serialize();
      var qty = $(this).parents("form").find(".qty-actual__input").value;

      var $thisButton = $(this).find("[data-add-to-cart-text]");
      var main_qty = parseInt($("#Quantity.qty-actual__input").val());
      var available_qty_of_variant = parseInt(
        $(".qty-wrapper").attr("data-qty")
      );
      if (main_qty == 0) {
        // $thisButton.html('Add to cart');
        $(".qty-wrapper")
          .find(".error_msg")
          .html("Please add atleat 1 quantity!")
          .show();
      } else if (available_qty_of_variant >= main_qty) {
        var originalText = $thisButton.html(
          '<span class="loader_custom">Adding <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="24" height="24" style="shape-rendering: auto; display: block; background: transparent;" xmlns:xlink="http://www.w3.org/1999/xlink"><g><circle cx="50" cy="50" r="32" stroke-width="8" stroke="#ffffff" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform></circle><g></g></g></span>'
        );
        $.ajax({
          type: "POST",
          url: "/cart/add",
          data: data,
          dataType: "html",
          success: function (response) {
            $thisButton.html("Add to cart");
            $(".qty-wrapper").find(".error_msg").hide();
            if (
              document.body.classList.contains("template-product") &&
              document.querySelector("#calculate") != null &&
              window.onProductAdded
            ) {
              window.onProductAdded(data);
            }
            $(".cart__drawer").addClass("show-cart__drawer");
            $("body").addClass("cv--show-cart__drawer");
            $(".cart__drawer-item").html(
              $(response).find(".cart__drawer-item").html()
            );
            $(".cart__drawer")
              .html($(response).filter(".cart__drawer").html())
              .addClass("show-cart__drawer");
            $(".header-cart__count").html(
              $(response).find(".header-cart__count").html()
            );

            // $('body, html').css('overflow', 'hidden');
            $(".cross").click(function () {
              $(".cart__drawer").removeClass("show-cart__drawer");
            });
            setTimeout(function () {
              $.ajax({
                type: "GET",
                url: "/",
                dataType: "html",
                success: function (response) {
                  $(".cart__drawer-item").html(
                    $(response).find(".cart__drawer-item").html()
                  );
                  $(".cart__drawer")
                    .html($(response).filter(".cart__drawer").html())
                    .addClass("show-cart__drawer");
                  $(".header-cart__count").html(
                    $(response).find(".header-cart__count").html()
                  );
                },
              });
            }, 1500);

            const cartJson = "/cart.js";
            async function getCartJson() {
              fetch(cartJson)
                .then((res) => {
                  return res.json();
                })
                .then((data) => {
                  //console.log(data);

                  var customEvent = new CustomEvent("cart-updated", {
                    detail: {
                      data: data,
                    },
                  });
                  window.dispatchEvent(customEvent);
                });
            }
            getCartJson();
          },
        });
      } else {
        // $thisButton.html('Add to cart');
        $(".qty-wrapper")
          .find(".error_msg")
          .html(
            `We apologise, but this item is currently limited on stock. Please <a href='tel:01409231763' style="color:#2A4125;">call us</a> or join our live chat to get updates on availability.`
          )
          .show();
      }
    }
  );

  // Cart Drawer Open On Click Cart Icon
  if (!$("body").hasClass("template-cart")) {
    $(document).on("click", ".header-cart", function (e) {
      e.preventDefault();
      $(".cart__drawer").addClass("show-cart__drawer");
      $("body").addClass("cv--show-cart__drawer");
      // $('body, html').css('overflow', 'hidden');
    });
  }
  // Cart Drawer Close On Click cross Icon
  $(document).on("click", ".cross", function () {
    $(".cart__drawer").removeClass("show-cart__drawer");
    $("body").removeClass("cv--show-cart__drawer");
    // $('body, html').css('overflow', 'auto');
  });
  //   Close Cart Drawer click anywhere
  $(document).mouseup(function (e) {
    var container = $(".cart__drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.show();
      $(".cart__drawer").removeClass("show-cart__drawer");
      $("body").removeClass("cv--show-cart__drawer");
      // $('body, html').css('overflow', 'auto');
    }
  });

  // Remove Item from Cart
  $(document).on("click", ".cart__remove", function (e) {
    e.preventDefault();
    var href = this.getAttribute("href");
    var target = this;
    var vid = parseInt(this.getAttribute("data-id"));
    getStatus("/cart.js", function (response) {
      var boardCount =
        response.items.find((item) => item.variant_id == 39606868934719)
          ?.quantity || 0;
      var planterCount =
        response.items.find((item) => item.variant_id == 39648912277567)
          ?.quantity || 0;
      var gatesCount =
        response.items.find((item) => item.variant_id == 39651602989119)
          ?.quantity || 0;
      var pairGatesCount =
        response.items.find((item) => item.variant_id == 39651603054655)
          ?.quantity || 0;
      var picketCount =
        response.items.find((item) => item.variant_id == 39651603087423)
          ?.quantity || 0;
      var panelCount =
        response.items.find((item) => item.variant_id == 39651603152959)
          ?.quantity || 0;
      var formData = {
        updates: {},
      };
      for (let i = 0; i < response.items.length; i++) {
        const item = response.items[i];
        const itemProperties = item.properties;

        if (item.id != 39606868934719 && itemProperties != null) {
          if (itemProperties.hasOwnProperty("bespoke-extra")) {
            var hasBoard = false;
            var hasPlanter = false;
            var hasGates = false;
            var hasPairGates = false;
            var hasPicket = false;
            var hasPanel = false;
            switch (itemProperties["bespoke-extra"]) {
              case "board":
                hasBoard = true;
                break;
              case "planter":
                hasPlanter = true;
                break;
              case "gates":
                hasGates = true;
                break;
              case "pair-gates":
                hasPairGates = true;
                break;
              case "picket":
                hasPicket = true;
                break;
              case "panel":
                hasPanel = true;
                break;
            }
            if (vid == item.id) {
              if (hasBoard) {
                formData["updates"][39606868934719] =
                  boardCount - item.quantity > 0
                    ? boardCount - item.quantity
                    : 0;
              }
              if (hasPlanter) {
                formData["updates"][39648912277567] =
                  planterCount - item.quantity > 0
                    ? planterCount - item.quantity
                    : 0;
              }
              if (hasGates) {
                formData["updates"][39651602989119] =
                  gatesCount - item.quantity > 0
                    ? gatesCount - item.quantity
                    : 0;
              }
              if (hasPairGates) {
                formData["updates"][39651603054655] =
                  pairGatesCount - item.quantity > 0
                    ? pairGatesCount - item.quantity
                    : 0;
              }
              if (hasPicket) {
                formData["updates"][39651603087423] =
                  picketCount - item.quantity > 0
                    ? picketCount - item.quantity
                    : 0;
              }
              if (hasPanel) {
                formData["updates"][39651603152959] =
                  panelCount - item.quantity > 0
                    ? panelCount - item.quantity
                    : 0;
              }
            }
          }
        }
      }
      formData["updates"][vid] = 0;
      fetch("".concat("/cart/update", ".js"), {
        body: JSON.stringify(formData),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function (cart) {
        $.ajax({
          type: "GET",
          url: "/",
          dataType: "html",
          success: function (response) {
            $(".cart__drawer-item").html(
              $(response).find(".cart__drawer-item").html()
            );
            $(".cart__drawer")
              .html($(response).filter(".cart__drawer").html())
              .addClass("show-cart__drawer");
            $(".header-cart__count").html(
              $(response).find(".header-cart__count").html()
            );
          },
        });
      });
    });
  });

  $(document)
    .ajaxStart(function () {
      // Show the progress bar and set its width to 10% when AJAX starts
      $("#progressBar").css("width", "10%").show();
    })
    .ajaxSend(function (event, jqXHR, ajaxOptions) {
      // Increase width gradually, indicating progress
      $("#progressBar").css("width", "50%"); // Mid-request width
    })
    .ajaxSuccess(function () {
      // Once the AJAX call successfully completes, expand to full width
      $("#progressBar").css("width", "100%");
    })
    .ajaxComplete(function () {
      // When AJAX completes, fade out and reset the progress bar
      $("#progressBar").fadeOut(400, function () {
        $(this).css("width", "0%");
      });
    });

  document.addEventListener("click", (e) => {
    const target = e.target.closest(".cart-submit:not(.goto_cart)");
    // console.log(e.target, target, "<<<<target checkout");
    if (target) {
      window.location.href = "/checkout";
    }
  });
});

// Change In Quantity Selector
document.addEventListener("DOMContentLoaded", function () {
  function showProgressBar() {
    $("#progressBar").css("width", "10%").show();
  }

  function updateProgressBar(percentage) {
    $("#progressBar").css("width", percentage + "%");
  }

  function hideProgressBar() {
    $("#progressBar").css("width", "100%"); // Completes the bar
    setTimeout(() => {
      $("#progressBar").fadeOut(400, function () {
        $(this).css("width", "0%"); // Reset after fade out
      });
    }, 500); // Delay to show completion before hiding
  }

  function handleQuantityUpdate(dataId, dataLine, parsedQuantity) {
    $(".cart__item-price").addClass("loading");

    function getCart(callback) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", "/cart.js");
      xhr.onload = function () {
        if (xhr.status === 200) {
          callback(JSON.parse(xhr.responseText));
        }
      };
      xhr.send();
    }

    getCart(function (cart) {
      const extraTypes = {
        board: 0,
        planter: 0,
        gates: 0,
        "pair-gates": 0,
        picket: 0,
        panel: 0,
      };

      cart.items.forEach((item, i) => {
        const props = item.properties;
        if (item.id === 39606868934719 || !props?.["bespoke-extra"]) return;

        const extra = props["bespoke-extra"];
        if (extraTypes.hasOwnProperty(extra)) {
          const itemQty = dataLine === i + 1 ? parsedQuantity : item.quantity;
          extraTypes[extra] += itemQty;
        }
      });

      const formData = {
        updates: {
          [dataId]: parsedQuantity,
        },
      };

      const idMap = {
        board: 39606868934719,
        planter: 39648912277567,
        gates: 39651602989119,
        "pair-gates": 39651603054655,
        picket: 39651603087423,
        panel: 39651603152959,
      };

      Object.keys(extraTypes).forEach((extra) => {
        if (cart.items.some((item) => item.id === idMap[extra])) {
          formData.updates[idMap[extra]] = extraTypes[extra];
        }
      });

      showProgressBar();

      fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(formData),
      })
        .then((res) => res.json())
        .then((cartData) => {
          updateProgressBar(80);
          const cartSectionId = document
            .querySelector(".cart")
            ?.getAttribute("data-section-id");

          $.ajax({
            type: "GET",
            url: theme.routes.cart_url + `?sections=header,${cartSectionId}`,
            success: function (data) {
              const replaceMap = {
                header: [
                  ".page-header .header-cart",
                  ".docked-navigation-container .header-cart",
                ],
                [cartSectionId]: [
                  '[data-section-type="cart"] .cart-items',
                  '[data-section-type="cart"] .subtotal-row',
                ],
              };
              Object.entries(replaceMap).forEach(([section, selectors]) => {
                const $newDom = $(data[section])
                  .find(".fade-in")
                  .removeClass("fade-in")
                  .end();
                selectors.forEach((sel) => {
                  $(sel).html($newDom.find(sel).html());
                });
              });
            },
          });

          $.ajax({
            type: "GET",
            url: "/",
            dataType: "html",
            success: function (response) {
              $(".cart__drawer-item").html(
                $(response).find(".cart__drawer-item").html()
              );
              $(".cart__drawer")
                .html($(response).filter(".cart__drawer").html())
                .addClass("show-cart__drawer");
              $(".header-cart__count").html(
                $(response).find(".header-cart__count").html()
              );
            },
          });
        })
        .finally(() => {
          hideProgressBar();
          setTimeout(() => {
            $(".cart__item-price").removeClass("loading");
          }, 700);
        });
    });
  }

  document.body.addEventListener("click", function (event) {
    if (
      !event.target.classList.contains("plus") &&
      !event.target.classList.contains("minus")
    )
      return;

    event.preventDefault();
    const button = event.target;
    const isMinus = button.classList.contains("minus");
    const target = isMinus
      ? button.nextElementSibling
      : button.previousElementSibling;

    const dataLine = parseInt(target.getAttribute("data-line"));
    const dataId = parseInt(target.getAttribute("data-id"));
    const parsedQuantity = isMinus
      ? Math.max(0, parseInt(target.value, 10) - 1)
      : parseInt(target.value, 10) + 1;

    target.value = parsedQuantity;
    handleQuantityUpdate(dataId, dataLine, parsedQuantity);
  });

  document.body.addEventListener("change", function (event) {
    if (!event.target.matches("input.item-qty")) return;

    const input = event.target;
    const parsedQuantity = Math.max(0, parseInt(input.value, 10));
    const dataLine = parseInt(input.getAttribute("data-line"));
    const dataId = parseInt(input.getAttribute("data-id"));

    input.value = parsedQuantity;
    handleQuantityUpdate(dataId, dataLine, parsedQuantity);
  });
});

setInterval(function () {
  const prices = document.querySelectorAll(
    ".cart__item-price > del + span.money"
  );

  prices.forEach((priceEl) => {
    const price_in_money = priceEl.innerText.replace(/[^\d.]/g, "");
    const container = priceEl.closest(".qty_price");
    const price_final =
      parseFloat(price_in_money) * container.querySelector(".item-qty").value;

    // console.log({ price_in_money, pe: priceEl.innerText, price_final });

    if (!container) return;

    const d = container.querySelector(".cart__item-price-dup");
    if (!d) return;

    const org_price = d.getAttribute("data-cent") / 100;
    if (!org_price || org_price <= price_final) return;
    const p = `
      <del class="money" style="padding-right:10px;">${WSAIO.formatMoney(
        org_price
      )}</del>
      <span class="money">${WSAIO.formatMoney(price_final)}</span>
    `;
    d.innerHTML = p;
  });
}, 100);
